export function setTime(time) {

  const input = time.toString().trim();
  let output = '';

  if (input.match(/^[0-9]{1}$/)) output = '0' + input + ':00';
  else if (input.match(/^[0-9]{2}$/)) output = input + ':00';
  else if (input.match(/^[0-9]{3}$/)) output = '0' + input.substr(0, 1) + ':' + input.substr(1, 2);
  else if (input.match(/^[0-9]{4}$/)) output = input.substr(0, 2) + ':' + input.substr(2, 2);

  else if (input.match(/^[0-9]{1}:[0-9]{1}$/)) output = '0' + input + '0';
  else if (input.match(/^[0-9]{1}:[0-9]{2}$/)) output = '0' + input;
  else if (input.match(/^[0-9]{2}:[0-9]{1}$/)) output = input + '0';

  else output = input;

  return output;
}
